"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { ComponentHeader } from "@/components/header/ComponentHeader";
import { AktivitetskravInfo } from "@/components/view/aktivitetskravInfo/AktivitetskravInfo";
import { MedUtenArbeidsgiverToggleGroup } from "@/components/view/aktivitetskravInfo/MedUtenArbeidsgiverToggleGroup";
import type { AktivitetskravVurdering } from "@/schema/aktivitetskravVurderingSchema";
export type MedUtenAGVisning = "MED_ARBEIDSGIVER" | "UTEN_ARBEIDSGIVER";
export const infoSideHeaderText = "Din aktivitetsplikt";
interface Props {
  vurdering: AktivitetskravVurdering;
}
export const UnderBehandlingComponent = t0 => {
  const $ = _c(8);
  const {
    vurdering
  } = t0;
  const [visning, setVisning] = useState("MED_ARBEIDSGIVER");
  let t1;
  if ($[0] !== vurdering.sistVurdert) {
    t1 = <ComponentHeader headerText={infoSideHeaderText} utsendtDato={vurdering.sistVurdert} alertStyle="info" />;
    $[0] = vurdering.sistVurdert;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <MedUtenArbeidsgiverToggleGroup setVisning={setVisning} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = visning === "MED_ARBEIDSGIVER";
  let t4;
  if ($[3] !== t3) {
    t4 = <AktivitetskravInfo harArbeidsgiver={t3} />;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t1 || $[6] !== t4) {
    t5 = <>{t1}{t2}{t4}</>;
    $[5] = t1;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};